<template>
  <li>
    <a v-if="external" :href="to" class="tool-link" target="_blank">
      <icon class="icon" :name="icon" /><span class="link-text">{{
        label
      }}</span>
    </a>
    <router-link v-else :to="to" class="tool-link">
      <icon class="icon" :name="icon" /><span class="link-text">{{
        label
      }}</span>
    </router-link>
  </li>
</template>
<script>
export default {
  props: {
    to: {
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    external: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/_css/variables";

.tool-link {
  &:hover {
    text-decoration-color: $text-default;
  }

  & > .icon {
    margin-right: 5px;
  }

  & > .link-text {
    color: $text-default;
  }
}
</style>
